const keyMirror = require("keymirror");

export const productConstant = keyMirror({
  GET_ALL_PRODUCT: undefined,
    SET_IMAGE_DETAIL:{}
});
